import { memo } from 'react';
import { AssignMenu, AddMenu, ShareMenu } from '~/services/config';
import { useSelector } from 'react-redux';

const noOp = () => {};

const Submenu = ({ role = 1, cid = 38, onClick = noOp, onClose = noOp }) => (
    <div className="sub-menu">
        <div className="sub-menu-backdrop" onClick={() => onClose()} />
        <ul className="list-group p-4 m-0">
            {cid != 38 && AddMenu[role].length > 0 && <p className="dsl-w14">Add</p>}
            {cid != 38 &&
                AddMenu[role].map((menu, index) => (
                    <p key={`add-menu-${index}`} className="list-group-item dsl-w14" onClick={() => onClick(menu)}>
                        {menu}
                    </p>
                ))}
            {ShareMenu[role].length > 0 && <p className="dsl-w14 mt-3">Share</p>}
            {ShareMenu[role].map((menu, index) => (
                <p className="list-group-item dsl-w14" key={`share-menu-${index}`} onClick={() => onClick(menu)}>
                    {menu}
                </p>
            ))}

            {/* {AssignMenu[role].length > 0 && <p className="dsl-w14 mt-3">Assign</p>}
      {AssignMenu[role].map((menu, index) => (
        <p
          className="list-group-item dsl-w14"
          key={`assign-menu-${index}`}
          onClick={() => onClick(menu)}
        >
          {menu}
        </p>
      ))} */}
        </ul>
    </div>
);

export default memo(Submenu);
